import React, { Component } from 'react'
import {
  Container,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap'

class Login extends Component {
  constructor () {
    super()

    this.state = {
      username: '',
      password: ''
    }

    this.onChange = this.onChange.bind(this)
    this.onLogin = this.onLogin.bind(this)
  }

  onChange (el) {
    this.setState({
      [el.target.name]: el.target.value
    })
  }

  onLogin (el) {
    el.preventDefault()

    this.props.login(this.state)
  }

  render () {
    const { username, password } = this.state

    return (
      <Container>
        <Form onSubmit={this.onLogin}>
          <h1 className='display-4'>Login</h1>
          <FormGroup>
            <Label for='username'>Username</Label>
            <Input type='text' name='username' id='username' value={username} onChange={this.onChange} />
          </FormGroup>
          <FormGroup>
            <Label for='password'>Password</Label>
            <Input type='password' name='password' value={password} id='password' onChange={this.onChange} />
          </FormGroup>
          <Button type='submit' color='success'>
            Login
          </Button>
        </Form>
      </Container>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/templates/Admin/Login/Login.js